import { z } from "zod";
export const carSchema = z.object({
  id: z.number(),
  label: z.string(),
  licence: z.string().nullable(),
  vin: z.string().nullable(),
  additional_info: z.string().nullable(),
  freestock_tire: z.boolean().default(false),
  relation: z.object({
    id: z.number(),
    name: z.string(),
  }),
  is_lease: z.boolean().default(false),
});

export const carFormSchema = z
  .object({
    licencePlate: z.string().optional().nullable(),
    vin: z.string().optional().nullable(),
    additional_info: z.string().optional().nullable(),
    freestock_tire: z.boolean().default(false),
  })
  .partial()
  .superRefine((data, refinementContext) => {
    if (
      data.licencePlate == undefined &&
      data.vin == undefined &&
      data.additional_info == undefined
    ) {
      refinementContext.addIssue({
        code: z.ZodIssueCode.custom,
        message: "License, VIN or extra information is required",
      });
    }
  });
